import React from "react"
import { FormattedMessage } from "react-intl"
import LinkWrapper from "../../../../common/rich-text/feature-protection-wrappers/linkWrapper.component"
import AccountLimit from "../../../../state/account-limit/AccountLimit"
import GlobalHelper from "../../../GlobalHelper"
import Icon from "../../../icon/icon.component.jsx"

interface OwnProps {
    accountLimits: AccountLimit
}

const QuoteCreationButton = (props: OwnProps) => {
    return (
        <LinkWrapper
            message={
                GlobalHelper.isAccountLimitExceeded(props.accountLimits.getDto())
                    ? <FormattedMessage
                        id="generic-listing.document-limit-exceeded"
                        defaultMessage="Documents limit exceeded."
                    />
                    : ""
            }
            to="/quotes/new"
            className="btn btn-primary"
            protectedClassName="btn btn-primary"
            protectionRule={!GlobalHelper.isAccountLimitExceeded(props.accountLimits.getDto())}
        >
            <span>
                <Icon value="plus-circle" />
                <FormattedMessage
                    id="generic-listing.quotes.create-btn-text"
                    defaultMessage="New quote"
                />
            </span>
        </LinkWrapper>
    )
}

export default QuoteCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/QuoteCreationButton.tsx